import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('nav', [_c('ul', {
    ref: "smyTab",
    staticClass: "smy-tab",
    style: 'padding-right:' + (_vm.rightWidth || 0) + 'px'
  }, [_vm.showAll ? _c('li', {
    ref: "smyTabList",
    staticClass: "smy-tab-list",
    on: {
      "click": function ($event) {
        _vm.realValue = _vm.allValue;
      }
    }
  }, [_c('div', {
    staticClass: "content-body"
  }, [_c('p', {
    class: {
      active: _vm.realValue === _vm.allValue
    }
  }, [_vm._v(" " + i18n.tc("67") + " ")])])]) : _vm._e(), _vm._l(_vm.list, function (item, index) {
    return _c('li', {
      key: item.value,
      ref: "smyTabList",
      refInFor: true,
      staticClass: "smy-tab-list",
      on: {
        "click": function ($event) {
          _vm.realValue = item.value;
        }
      }
    }, [_c('div', {
      staticClass: "content-body"
    }, [_c('p', {
      class: {
        active: _vm.realValue === item.value
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), item.value !== '' && _vm.showBadge ? _c('div', {
      staticClass: "badge"
    }, [_c('span', [_vm._v(_vm._s(_vm.badgeCountList[item.value] || 0))])]) : _vm._e()])]);
  })], 2), _vm.hasRightSlot ? _c('div', {
    staticClass: "smy-tab-right"
  }, [_vm._t("right")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };